import { Text } from "@/components/ui";
import type { ReactNode } from "react";

type ReportsPageLayoutProps = {
  title: string;
  headerActions?: ReactNode;
  children: ReactNode;
};

export function ReportsPageLayout({
  title,
  headerActions,
  children,
}: ReportsPageLayoutProps) {
  return (
    <div className="flex w-full flex-col gap-6">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
        <div className="gap-y-1">
          <Text variant="title">{title}</Text>
        </div>
        {headerActions ? (
          <div className="w-full lg:w-auto lg:flex-none">{headerActions}</div>
        ) : null}
      </div>
      {children}
    </div>
  );
}
